import { createSlice } from '@reduxjs/toolkit'

interface PageToolbarState {
  isFixed: boolean
}

interface ComponentsState {
  PageToolbar: PageToolbarState
}

const initialState: ComponentsState = {
  PageToolbar: {
    isFixed: false
  }
}

const slice = createSlice({
  name: 'components',
  initialState,
  reducers: {
    setPageToolbarIsFixed(state, action) {
      state.PageToolbar.isFixed = action.payload
    }
  }
})

export const { setPageToolbarIsFixed } = slice.actions

export default slice.reducer
